import { useAuth0 } from "@auth0/auth0-react"
import { ChevronDown } from "lucide-react"
import { Button } from "@components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu"

export const UserMenu = () => {
  const { user, logout } = useAuth0()

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="tw:ml-auto tw:h-auto tw:py-1">
          <img
            referrerPolicy="no-referrer"
            src={user?.picture}
            className="tw:size-8 tw:rounded-full"
            alt=""
          />
          <span>{user?.name}</span>
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="tw:w-36" align="end">
        <DropdownMenuItem onClick={handleLogout} className="tw:cursor-pointer">
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
